import { Grid, Radio } from '@mui/material';

import { RoutalPalette } from '@nx-smartmonkey/ui';
import { GeoFenceDTO } from '../../../../domain/geoFence/GeoFenceDTO';
import { intl } from '../../../../helpers/IntGlobalProvider';
import { GeoFenceMapper } from '../../../../mappers/geoFence/GeoFenceMapper';
import { GeoFencesSelector } from '../../../../react-components/GeoFencesSelector';
import Text from '../../../../react-components/Text';
import { SearchFilterComponent } from '../filter';
import { SearchFilterOperators } from '../filter/SearchFilter';
import { SearchFilterGeojson } from './SearchFilterGeojson';

interface GetSearchFilterGeojsonOptionsProps {
  operator: SearchFilterOperators;
  text: string;
  isSelected: boolean;
}

const getSearchFilterGeojsonOptions = (filter: SearchFilterGeojson): GetSearchFilterGeojsonOptionsProps[] => [
  {
    operator: `in`,
    text: intl.formatMessage({ id: `search_filters.in` }),
    isSelected: filter.isOperator(`in`),
  },
  {
    operator: `nin`,
    text: intl.formatMessage({ id: `search_filters.nin` }),
    isSelected: filter.isOperator(`nin`),
  },
];

interface SearchFilterGeojsonComponentProps {
  filter: SearchFilterGeojson;
  filterPosition: number;
  colors: {
    primaryColor: string;
    secondaryColor: string;
  };
  onChange: (filter: SearchFilterGeojson) => void;
  onRemoveFilter: () => void;
}

export const SearchFilterGeojsonComponent = ({
  filter,
  filterPosition,
  colors,
  onChange,
  onRemoveFilter,
}: SearchFilterGeojsonComponentProps) => {
  const geoFencesDict = filter.getListOptions().reduce((acc, curr) => {
    acc[curr.value.id] = curr.value;
    return acc;
  }, {} as Record<string, GeoFenceDTO>);

  return (
    <SearchFilterComponent
      filter={filter}
      buttonId={`filter-geojson-${filterPosition}`}
      colors={colors}
      onRemoveFilter={onRemoveFilter}
    >
      {getSearchFilterGeojsonOptions(filter).map((option) => {
        return (
          <Grid container direction="column" wrap="nowrap" style={{ padding: `0 16px`, minWidth: `250px` }}>
            <Grid
              item
              container
              direction="row"
              wrap="nowrap"
              alignItems="center"
              style={{
                cursor: `pointer`,
              }}
              onClick={(event: any) => {
                event.stopPropagation();
                filter.setOperator(option.operator);
                onChange(filter);
              }}
            >
              <Grid item>
                <Radio
                  style={{
                    color: colors.primaryColor,
                  }}
                  checked={option.isSelected}
                  onChange={(event: any) => {
                    event.stopPropagation();
                    filter.setOperator(option.operator);
                    onChange(filter);
                  }}
                />
              </Grid>

              <Grid item>
                <Text style={{ cursor: `pointer` }}>{option.text}</Text>
              </Grid>
            </Grid>

            {option.isSelected ? (
              <Grid item>
                <GeoFencesSelector
                  geoFences={filter.getListOptions().map((option) => GeoFenceMapper.toDomain(option.value)) ?? []}
                  selectedGeoFenceIds={filter.getValue().map((gF: any) => gF.id)}
                  selectButtonStyles={{
                    width: `240px`,
                  }}
                  noSelectedZonesText={
                    <Text
                      style={{ color: RoutalPalette.secondary40, cursor: `pointer` }}
                      intlId="planner.stops.no_zones_selected"
                    />
                  }
                  handleUpdate={(geoFences: string[]) => {
                    filter.setValue(geoFences.map((gF) => geoFencesDict[gF]).filter((gF) => gF));
                    onChange(filter);
                  }}
                />
              </Grid>
            ) : null}
          </Grid>
        );
      })}
    </SearchFilterComponent>
  );
};
